export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getRefundMethods: function getRefundMethods(policyNumber, tempCancellation) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getValidRefundMethods', [policyNumber, tempCancellation]);
        },
        getEffectiveDateForCancellation: function getEffectiveDateForCancellation(policyNumber, tempCancellation) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getEffectiveDateForCancellation', [policyNumber, tempCancellation]);
        },
        findJobByJobNumber: function findJobByJobNumber(cancellationNumber) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'findJobByJobNumber', [cancellationNumber]);
        },
        getCancellationSummary: function getCancellationSummary(cancellationNumber) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getCancellationSummary', [cancellationNumber]);
        },
        getNotesForCancellation: function getNotesForCancellation(cancellationNumber) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getNotesForCancellation', [cancellationNumber]);
        },
        createNoteForCancellation: function createNoteForCancellation(cancellationNumber, noteDTO) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'createNoteForCancellation', [cancellationNumber, noteDTO]);
        },
        getDocumentsForCancellation: function getDocumentsForCancellation(cancellationNumber) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getDocumentsForCancellation', [cancellationNumber]);
        },
        getUWIssuesForCancellation: function getUWIssuesForCancellation(cancellationNumber) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getUWIssuesForCancellation', [cancellationNumber]);
        },
        referToUnderwriter: function referToUnderwriter(cancellationNumber, noteBody) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'referToUnderwriter', [cancellationNumber, noteBody]);
        },
        withdrawCancellationByCancellationNumber: function withdrawCancellationByCancellationNumber(cancellationNumber) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'withdrawCancellationByJobNumber', [cancellationNumber]);
        },
        startCancellation: function startCancellation(policyNumber, cancellation) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'startCancellation', [policyNumber, cancellation]);
        },
        bindCancellation: function bindCancellation(cancellationNumber) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'bindCancellation', [cancellationNumber]);
        },
        getRefundValue: function getRefundValue(effectiveDate, policyEffDate) {
            return JsonRPCService.send('pc', 'gateway/cancellation', 'getRefundValues', [effectiveDate, policyEffDate]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/CancellationService.js
// module id = 1784
// module chunks = 0